var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { Provider } from 'react-redux';
import { getRoutes } from "./Routes";
import CustomProvider from "./App/Provider";
import { settingsAtom } from "./V2/atoms/settingsAtom";
import { store } from "./store";

const reduxState = store === null || store === void 0 ? void 0 : store.getState();

const settings = (reduxState === null || reduxState === void 0 ? void 0 : reduxState.settings.collection.toJS()) || {};

const router = createBrowserRouter(getRoutes(settings, reduxState === null || reduxState === void 0 ? void 0 : reduxState.user.get('_id')));

const recoilGlobalState = ({ set }) => {
  set(settingsAtom, settings);
};

const App = () => /*#__PURE__*/
_jsx(Provider, { store: store }, void 0, /*#__PURE__*/
_jsx(CustomProvider, {}, void 0, /*#__PURE__*/
_jsx(RecoilRoot, { initializeState: recoilGlobalState }, void 0, /*#__PURE__*/
_jsx(RouterProvider, { router: router, fallbackElement: null })
)
)
);


export { App };